var React = require('react');

function GreenCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.21973 9.66019L2.77973 6.00019L0.219727 9.00019L7.77973 15.3002L17.5497 3.2202L14.4497 0.700195L7.21973 9.66019Z","fill":"#4AA997"}));
}

GreenCheck.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none"};

module.exports = GreenCheck;

GreenCheck.default = GreenCheck;
